"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.transparent = exports.secondary = exports.primaryWash = exports.primary = exports.positive = exports.negative = exports.backgroundOverlay = exports.backgroundAlternate = exports.background = void 0;
require("./backgroundColor.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const background = "cds-background-b85wjan";
exports.background = background;
const backgroundAlternate = "cds-backgroundAlternate-b1o0kdmt";
exports.backgroundAlternate = backgroundAlternate;
const backgroundOverlay = "cds-backgroundOverlay-b1sqpo3z";
exports.backgroundOverlay = backgroundOverlay;
const primary = "cds-primary-pzplokk";
exports.primary = primary;
const primaryWash = "cds-primaryWash-p120bo8c";
exports.primaryWash = primaryWash;
const secondary = "cds-secondary-s92gew2";
exports.secondary = secondary;
const positive = "cds-positive-pwmx8ah";
exports.positive = positive;
const negative = "cds-negative-np4le5t";
exports.negative = negative;
const transparent = "cds-transparent-t7zqpbe";
exports.transparent = transparent;
const warning = "cds-warning-w1bqsxh7";
exports.warning = warning;